import { Action } from "@/interface/action";

let initialState = {
  info: {},
}

export const Token = (state = initialState, action: Action) => {
  switch (action.type) {
    case "SET_TOKEN_INFO":
    case "REFRESH_TOKEN_INFO":
      return {...state, info: action.payload };
    case "RESET_TOKEN_INFO":
      return initialState;
    default:
      // 默认情况下，返回当前状态，不做任何改变
      return state;
  }
}